/* unplugin-vue-components disabled */import "core-js/modules/es.array.push.js";
import { useEmptyStringFormat } from '@/hooks/fn';
export default defineComponent({
  name: 'YieldSum',
  components: {},
  props: {
    data: {
      type: Object,
      required: true
    },
    isJump: {
      type: String,
      default: '0'
    },
    curDate: {
      type: String,
      default: ''
    }
  },
  setup: function setup(props) {
    var emptyStringFormat = useEmptyStringFormat();
    var router = useRouter();
    var toCheckDevice = function toCheckDevice() {
      router.push({
        name: 'ProEquipmentLive'
      });
    };
    var toYieldCorrection = function toYieldCorrection() {
      router.push({
        name: 'YieldCorrection',
        params: {
          date: props.curDate
        }
      });
    };
    return {
      emptyStringFormat: emptyStringFormat,
      toCheckDevice: toCheckDevice,
      toYieldCorrection: toYieldCorrection
    };
  }
});